module.exports = __webpack_public_path__ + "static/media/like-gray.2cb1e340.svg";